/*
 * @Author: ttheitao
 * @Date: 2024-03-29 10:58:07
 * @Description: some description
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-07-02 17:11:31
 */

import { syncToLocal } from "@/api/baseApi";
import { refresh } from "@/store/bookmarks";
import { ref } from 'vue'
const databaseDb = ref(null)
interface IstoreNames {
  bookmarks: string,
  categories: string,
  logs: string,
}
export { databaseDb }
export default class Database {
  public static databaseName: string;
  public static storeNames: IstoreNames;
  public static db: IDBDatabase;
  public isUpgrad: boolean;

  constructor() {
    Database.databaseName = "BIMCC_onetab";
    Database.storeNames = {
      bookmarks: 'bookmarks',
      categories: 'categories',
      logs: 'logs',
    };

    this.isUpgrad = false;
    this.init();
  }

  static create() {
    return new Database();
  }

  public init() {
    const request = window.indexedDB.open(Database.databaseName, 1);
    request.onsuccess = async (e: any) => {
      Database.db = e.target.result as IDBDatabase;
      databaseDb.value = Database.db
      refresh();
      if (!this.isUpgrad) {
        syncToLocal().then(res => {
          refresh();
        });
      }
    };

    request.onerror = (e) => {
      console.log(e);
    };

    request.onupgradeneeded = (e: any) => {
      this.isUpgrad = true;
      console.log('onupgradeneeded');
      const db = e.target.result as IDBDatabase;
      Database.db = db;
      const objectStoreNames = db.objectStoreNames;

      if (!objectStoreNames.contains(Database.storeNames.bookmarks)) {
        const bookmarkStore = db.createObjectStore(Database.storeNames.bookmarks, { keyPath: 'uuid', autoIncrement: false });
        const categoryStore = db.createObjectStore(Database.storeNames.categories, { keyPath: 'uuid', autoIncrement: false });
        const logsStore = db.createObjectStore(Database.storeNames.logs, { keyPath: 'type', autoIncrement: false });

        categoryStore.transaction.oncomplete = (event: any) => {
          this.isUpgrad = false;
          syncToLocal().then(res => {
            refresh();
          });
        };
      }
    };
  }
}